import BrandsIndexPage from '../../components/pages/brands/BrandsIndexPage'

export default {
  components: { BrandsIndexPage }
}
